import { ParamMap } from '@angular/router';

/**
 * Whether the game is played offline (`?offline=1`): with a save in localStorage and local homework, without an account
 * and without ever talking to the backend.
 */
export function isOfflinePlay(queryParams: ParamMap): boolean {
  return queryParams.get('offline') === '1';
}
